const thermostatsColumns = {
  id: {
    key: 'id',
    label: 'id',
    type: 'text',
    sortable: false,
    minWidth: 10,
  },
  name: {
    key: 'name',
    label: 'name',
    type: 'text',
    sortable: false,
  },
  currentTemperature: {
    key: 'currentTemperature',
    label: 'currentTemperature',
    type: 'function',
    get: (temperature) => (temperature ? `${temperature.value} ˚C` : '-'),
    minWidth: 20,
    sortable: false,
  },
  enabled: {
    label: 'enabled',
    type: 'boolean',
    minWidth: 10,
    sortable: false,
    align: 'center',
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 20,
    buttons: [
      {
        name: 'editThermostat',
        icon: 'fas fa-pencil',
        permissions: ['thermostatsManage'],
      },
      {
        name: 'editTemperature',
        icon: 'fas fa-thermometer-half',
        permissions: ['thermostatsManage'],
      },
      {
        name: 'showTempsHistory',
        icon: 'fas fa-history',
        permissions: ['thermostatsView'],
      },
    ],
  },
};

export default thermostatsColumns;
